<template>
    <copy-shell
        :dialog-show="dialogShow"
        :title-drawer="$t('Confirm_your_order')"
        @close="closeHandle"
    >
        <div class="drawer-content-inner car-sure-order"
        >
          <div class="shipping-address">
            <div class="address-header">
              <h2 class="title">{{$t('Delivery_address')}}</h2>
              <div
                @click="editAddressHandle"
                class="header-right pointer">
                <i class="iconfont iconbianji"></i>
                <span>{{$t('Edit')}}</span>
              </div>
            </div>
            <div class="address-detail">
              <i class="iconfont icon-shouhuodizhi icon"></i>
              <div class="icon-right">
                <span class="no-address" v-if="!carInfo.shippingInfo">{{$t('root.noData')}}</span>

                <p
                  v-if="carInfo.shippingInfo"
                  class="consignee-information"
                >
                  <span class="consignee-name">{{carInfo.shippingInfo.name}}</span>
                  <span class="consignee-phone">{{carInfo.shippingInfo.phone}}</span>
                </p>
                <p
                  v-if="carInfo.shippingInfo"
                  class="address-real">{{carInfo.shippingInfo.address}}</p>
              </div>
            </div>
            <p
              v-if="validateAddressFlag"
              class="validate-text">{{$t('Please_fill_in_the_delivery_address')}}</p>
          </div>
          <div class="order-content">
            <div class="order-title">{{$t('Order_Information')}}</div>
            <div class="order-list">
              <div
                v-for="(item,index) in carOrderList"
                :key="index"
                class="order-item">
                <div class="item-top">
                  <div class="top-left">
                    <div class="img-box">
                      <img class="img-el" :src="item.frontImg" alt="">
                    </div>
                    <div class="product-info">
                      <div class="product-name">{{item.productName}}</div>
                      <div class="integral">
                        <span class="text">积分</span>
                        <span class="integral-number">{{item.quantity * item.unitPrice}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="top-right">X {{item.quantity}}</div>
                </div>
                <div class="item-bot">
                  <div
                    v-if="item.productType == 1"
                    class="remarl-or-select-box">
                    <span class="label">备注</span>
                    <el-input
                      class="input-el"
                      size="mini"
                      v-model="item.remark"
                      :placeholder="$t('optional')"
                      maxlength="20"
                      show-word-limit
                    ></el-input>
                  </div>
                  <div
                    v-if="item.productType == 2"
                    class="remarl-or-select-box">
                    <span class="label">MT4</span>
                    <el-select
                      class="select-el"
                      size="mini"
                      v-model="item.mt4Id"
                      :placeholder="$t('please_choose')"
                    >
                      <el-option
                        v-for="(item,index) in mtAccList"
                        :key="index"
                        :label="item.login"
                        :value="item.login"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-box padding20"
             slot="footer"
        >
            <el-button
              class="open-btn"
              style="width: 100%"
              type="primary"
              @click="applySubmitHandle"
            >{{$t('Apply_for_redemption')}}</el-button>
        </div>
    </copy-shell>
</template>

<script>
  import { mapGetters } from 'vuex'
    import copyShell from '@/components/common/copyShell';
    import { mtAccList,applyExchange } from '@/api/userCenter.js';
  export default {
    name: 'sureOrderDialog',
    props: {
      dialogShow: {
        type: Boolean,
        default: false,
      },
      carInfo:{
        type: Object,
        default(){
          return {
            shippingInfo: {
              "name": "",
              "nationCode": "+86",
              "phone": "",
              "city": "",
              "detailedAddress": "",
            },
          }
        }
      },
      settleProductArr:{
        type: Array,
        default(){
          return {}
        },
      }
    },
    components:{
      copyShell,
    },
    data() {
      let _this = this;
      return {


        validateAddressFlag: false,
        mtAccList: [],
        carOrderList:[],
      };
    },
    created(){
      this.getCustMtaccount();
    },
    watch:{
      settleProductArr(newValue){
        if(newValue){
          this.carOrderList = JSON.parse(JSON.stringify(newValue));
        }
      },
    },
    computed: {
      ...mapGetters(['userInfo',]),
    },
    methods: {
      closeHandle() {
        this.$emit('close');
      },
      editAddressHandle(){
        this.$emit('edit-address');
      },
      getCustMtaccount(){
        //根据获取不同的帐号列表
        let mtAccListData = {
          id : this.userInfo.id,
          businessTypes: '0,1,2,3',
        }

        mtAccList(mtAccListData).then((res) => {
          this.mtAccList = res.data;
        })
      },
      applySubmitHandle(){
        //订单信息全是虚拟品的情况下不需要验证地址, 验证 todo
        let isHasGood = this.carOrderList.some((item) => {
          return item.productType == 1;
        });
        if(isHasGood && !this.carInfo.shippingInfo){
          this.$message({
            message: '请添加收货地址'
          });
          return;
        }
        let isNoSelectMt4 = this.carOrderList.every((item) => {
          if(item.productType == 2){
            return item.mt4Id;
          }else {
            return true;
          }
        });
        if(!isNoSelectMt4){
          this.$message({
            message: '赠金类型商品请选择相应的mt4'
          });
          return;
        }
        let paramsArr = [];
        for (let i = 0; i <this.carOrderList.length; i++) {
          let pushItem = {
            cartId: this.carOrderList[i].cartId,
          }
          if(this.carOrderList[i].productType == 1){
            pushItem.remark = this.carOrderList[i].remark + '';
          }else if(this.carOrderList[i].productType == 2){
            pushItem.remark = this.carOrderList[i].mt4Id + '';
          }
          paramsArr.push(pushItem);
        }
        applyExchange(paramsArr).then((res) => {
          if(res&&res.code&&res.code == 200){
            console.log(res);
            this.$message({
              type: 'success',
              message: '提交成功'
            });
            this.$emit('exchange-success');
          }else{
            this.$message.error(res.msg);
          }
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
    @import "../../../assets/scss/variable";
.car-sure-order {
  .shipping-address {
    margin-bottom: 30px;
    .address-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .title {
        font-weight: 600;
        color: #333333;
        font-size: 16px;
      }
      .header-right {
        font-size: 14px;
        color: #999999;
      }
    }
    .address-detail {
      background-color: #F6F8FA;
      padding: 17px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .icon {
        color: $themeColor;
        margin-right: 10px;
      }
      .icon-right {
        color: #333333;
        font-size: 14px;
        .no-address,
        .consignee-phone {
          color: #999999;
        }
        .consignee-information {
          margin-bottom: 5px;
        }
      }
      .consignee-name {
        padding-right: 10px;
      }
    }
  }
  .order-content {
    .order-title {
       font-size: 16px;
      font-weight: 600;
      margin-bottom: 30px;
    }
  }
  .order-item {
      margin-bottom: 20px;
      font-size: 14px;
      .item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .top-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .img-box {
          width: 48px;
          height: 48px;
          margin: 0 10px;
          .img-el {
            width: 100%;
            height: 100%;
          }
        }
        .product-info {
            .product-name {
              color: #333333;
              margin-bottom: 10px;
            }
            .text {
              color: #999999;
            }
          .integral-number {
            color: $themeColor;
          }
        }
      }
    .item-bot {
      padding-left: 68px;
      .remarl-or-select-box {
        height: 32px;
        border: 1px solid #C8C8C8;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 15px;
        margin-top: 15px;
        /deep/ .el-input__inner {
          border: none;
        }
        .label {
          width: 40px;
        }
        .select-el,
        .input-el {
          flex: 1;
        }
      }
    }
  }
}
    .footer-box {
        padding-top: 10px;
        padding-bottom: 10px;

    }
</style>
